export function titleize(string: unknown) {
  if (typeof string !== 'string') return '';

  return string.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, (x) => x.toUpperCase());
}

export function titleizeWithSpaces(str: string) {
  return str
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .replace(/([-])/g, ' ')
    .trim();
}
